import { Link } from 'react-router-dom'

/**
 * SMS/Email Opt-In Component for Twilio compliance
 *
 * @param {Object} props
 * @param {boolean} props.transactionalConsent - Required: consent for transactional messages
 * @param {Function} props.onTransactionalChange - Handler for transactional consent change
 * @param {boolean} props.marketingConsent - Optional: consent for marketing messages
 * @param {Function} props.onMarketingChange - Handler for marketing consent change
 * @param {boolean} props.showMarketing - Whether to show marketing checkbox (default: true)
 * @param {string} props.className - Additional CSS classes
 */
const SmsEmailOptIn = ({
  transactionalConsent,
  onTransactionalChange,
  marketingConsent,
  onMarketingChange,
  showMarketing = true,
  className = ''
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {/* Transactional Consent - Required */}
      <label className="flex items-start gap-3 cursor-pointer group">
        <input
          type="checkbox"
          checked={transactionalConsent}
          onChange={(e) => onTransactionalChange(e.target.checked)}
          required
          className="mt-1 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
        />
        <span className="text-sm text-gray-600 leading-relaxed">
          I agree to receive SMS and email notifications from Love & Photos LLC related to my booking, account, or services, including confirmations, reminders, updates, and support messages. Message frequency varies. Message and data rates may apply for SMS. Reply STOP to unsubscribe or HELP for help at any time.
          <span className="text-red-500 ml-1">*</span>
        </span>
      </label>

      {/* Marketing Consent - Optional */}
      {showMarketing && (
        <label className="flex items-start gap-3 cursor-pointer group">
          <input
            type="checkbox"
            checked={marketingConsent}
            onChange={(e) => onMarketingChange(e.target.checked)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
          />
          <span className="text-sm text-gray-600 leading-relaxed">
            I agree to receive occasional marketing and promotional messages via SMS and email from Love & Photos LLC, including offers, updates, and announcements. Message frequency varies. Message and data rates may apply for SMS. Reply STOP to unsubscribe or HELP for help at any time.
          </span>
        </label>
      )}

      {/* Privacy Policy & Terms Links */}
      <div className="text-sm text-gray-500">
        <Link to="/privacy" className="text-primary-600 hover:text-primary-700 underline">
          Privacy Policy
        </Link>
        {' & '}
        <Link to="/terms" className="text-primary-600 hover:text-primary-700 underline">
          Terms and Conditions
        </Link>
      </div>
    </div>
  )
}

export default SmsEmailOptIn
